import React from "react";
import { cn } from "../../utils/lib";
import { Tooltip } from "./Tooltip";

interface IconButtonProps {
  onClick?: () => void;
  icon: any;
  color?: "primary" | "red" | "green" | "yellow" | "blue" | "gray";
  disabled?: boolean;
  padding?: string;
  className?: string;
  ariaLabel?: string;
  isTooltip?: boolean;
  tooltipText?: string;
  position?: "top" | "bottom" | "left" | "right";
}
const IconButton = ({
  onClick,
  icon,
  color = "primary",
  disabled = false,
  padding,
  className,
  ariaLabel,
  isTooltip = false,
  tooltipText = "",
  position = "top",
}: IconButtonProps) => {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onClick && onClick();
  };

  const buttonContent = (
    <button
      type="button"
      className={cn(
        "rounded-full bg-transparent transition-all duration-300 active:scale-95",
        padding || "p-1.5",
        disabled ? "cursor-not-allowed opacity-25" : "cursor-pointer",
        COLORS[color],
        className,
      )}
      onClick={handleClick}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      {icon}
    </button>
  );

  return isTooltip ? (
    <Tooltip disabled={disabled} tooltipText={tooltipText} position={position}>
      {buttonContent}
    </Tooltip>
  ) : (
    buttonContent
  );
};

export { IconButton };

const COLORS = {
  primary: "text-indigo-700 hover:text-primary hover:bg-indigo-100",
  red: "text-red-700 hover:text-red-800 hover:bg-red-100",
  green: "text-green-700 hover:text-green-800 hover:bg-green-100",
  yellow: "text-yellow-700 hover:text-yellow-800 hover:bg-yellow-100",
  blue: "text-blue-700 hover:text-blue-800 hover:bg-blue-100",
  purple: "text-purple-700 hover:text-purple-800 hover:bg-purple-100",
  gray: "text-gray-700 hover:text-gray-800 hover:bg-gray-100",
  orange: "text-orange-700 hover:text-orange-800 hover:bg-orange-100",
};
